export default {
  title: 'Czy na pewno chcesz usunąć swoje konto?',
  description:
    'Ta akcja jest nieodwracalna. Utracisz dostęp do zamówień, punktów lojalnościowych i zapisanych preferencji.',
  labels: {
    loading: 'Usuwanie konta...',
  },
  buttons: {
    confirm: 'Potwierdź',
    cancel: 'Anuluj',
  },
  toasts: {
    success:
      'Twoje konto zostało trwale usunięte. Nie masz już dostępu do historii zamówień, punktów lojalnościowych ani zapisanych danych.',
    error:
      'Coś poszło nie tak. Spróbuj ponownie. Jeśli problem się utrzymuje, skontaktuj się z naszym zespołem wsparcia: {{supportEmail}}',
  },
};
